module.exports = __webpack_public_path__ + "static/media/baltimore-happy-hour-logo-black.605522fc.png";